<template>
    <div class='goodsnumscon'>
          <div class="goodsnumscon-op" @click="dec">-</div>
          <div><input class='goodsnumscon-digit' :value='cartnums' @blur='updatenums'/></div>
          <div class="goodsnumscon-op plus" @click="add">+</div>
    </div>
</template>
<script>
export default {
  name: 'GoodsNums',
  props: {
    item: Object,
    minnums:{type:Number,default:0}
  },
  computed:{
    cartnums(){
        return this.$store.getters.itemnums(this.item.id,this.$store.state.cart.clicked)
    },
    basetotal(){
        return this.$store.getters.basetotal(this.$store.state.cart.clicked)
    }
  },
  methods:{
      add(){
         this.$store.commit('ADD_TO_CART',{goodsItem:this.item})
         this.$store.commit('UPDATE_NOWPRICE',{total:this.basetotal,pricelevel:this.item.pricelevel})
      },
      dec(){
         if(this.cartnums>this.minnums){
             this.$store.commit('DEL_FROM_CART',{goodsItem:this.item})
             this.$store.commit('UPDATE_NOWPRICE',{total:this.basetotal,pricelevel:this.item.pricelevel})
         }
      },
      updatenums(e){
         let nums=parseInt(e.target.value)
         if(nums>this.minnums){
            this.$store.commit('UPDATE_NUMS',{goodsid:this.item.id,goodsnums:nums,goodsitem:this.item})
            this.$store.commit('UPDATE_NOWPRICE',{total:this.basetotal,pricelevel:this.item.pricelevel})
         }else{
            this.$store.commit('UPDATE_NUMS',{goodsid:this.item.id,goodsnums:this.minnums,goodsitem:this.item})
            this.$store.commit('UPDATE_NOWPRICE',{total:this.basetotal,pricelevel:this.item.pricelevel})
         }
      }
  }
}
</script>
<style scoped>
.goodsnumscon{display: flex;}
.goodsnumscon-op{background-color: #f7f7f7;color:#7d7d7d;width:0.8rem;height:0.8rem;display: flex;justify-content: center;align-items: center;font-size:0.8rem;margin: 0 0.2rem;user-select: none;}
.plus{color:#d88045}
.goodsnumscon-digit{background-color: #f7f7f7;color:#7d7d7d;width:1.6rem;height:0.8rem;display: flex;justify-content: center;align-items: center;font-size:0.5rem;text-align: center;}
</style>


